import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  editFieldAriaLabel: {
    id: 'course-authoring.course-outline.card.edit-field.aria-label',
    defaultMessage: 'Edit field',
  },
  expandTooltip: {
    id: 'course-authoring.course-outline.card.expandTooltip',
    defaultMessage: 'Collapse/Expand this card',
  },
  statusBadgeLive: {
    id: 'course-authoring.course-outline.card.status-badge.live',
    defaultMessage: 'Live',
  },
  statusBadgeGated: {
    id: 'course-authoring.course-outline.card.status-badge.gated',
    defaultMessage: 'Gated',
  },
  statusBadgePublishedNotLive: {
    id: 'course-authoring.course-outline.card.status-badge.published-not-live',
    defaultMessage: 'Published not live',
  },
  statusBadgeStaffOnly: {
    id: 'course-authoring.course-outline.card.status-badge.staff-only',
    defaultMessage: 'Staff only',
  },
  statusBadgeDraft: {
    id: 'course-authoring.course-outline.card.status-badge.draft',
    defaultMessage: 'Draft',
  },
  statusBadgeUnpublishedChanges: {
    id: 'course-authoring.course-outline.card.status-badge.draft-unpublished-changes',
    defaultMessage: 'Draft (Unpublished changes)',
  },
  altButtonRename: {
    id: 'course-authoring.course-outline.card.button.edit.alt',
    defaultMessage: 'Rename',
  },
  menuPreview: {
    id: 'course-authoring.course-outline.card.menu.preview',
    defaultMessage: 'Preview',
  },
  menuPublish: {
    id: 'course-authoring.course-outline.card.menu.publish',
    defaultMessage: 'Publish',
  },
  menuConfigure: {
    id: 'course-authoring.course-outline.card.menu.configure',
    defaultMessage: 'Configure',
  },
  menuDuplicate: {
    id: 'course-authoring.course-outline.card.menu.duplicate',
    defaultMessage: 'Duplicate',
  },
  menuMoveUp: {
    id: 'course-authoring.course-outline.card.menu.moveup',
    defaultMessage: 'Move up',
  },
  menuMoveDown: {
    id: 'course-authoring.course-outline.card.menu.movedown',
    defaultMessage: 'Move down',
  },
  menuDelete: {
    id: 'course-authoring.course-outline.card.menu.delete',
    defaultMessage: 'Delete',
  },
  menuUnlink: {
    id: 'course-authoring.course-outline.card.menu.unlink',
    defaultMessage: 'Unlink from Library',
    description: 'Unlink an item from the library',
  },
  menuUnlinkDisabledTooltip: {
    id: 'course-authoring.course-outline.card.menu.unlink.disabled-tooltip',
    defaultMessage: 'Only the highest level library reference can be unlinked.',
    description: 'Tooltip for disabled unlink option',
  },
  menuCopy: {
    id: 'course-authoring.course-outline.card.menu.copy',
    defaultMessage: 'Copy to clipboard',
  },
  menuProctoringLinkText: {
    id: 'course-authoring.course-outline.card.menu.proctoring-settings',
    defaultMessage: 'Proctoring settings',
  },
  proctoringLinkTooltip: {
    id: 'course-authoring.course-outline.card.menu.proctoring-settings-tooltip',
    defaultMessage: 'Proctoring settings',
  },
  discussionEnabledBadgeText: {
    id: 'course-authoring.course-outline.card.badge.discussionEnabled',
    defaultMessage: 'Discussions enabled',
  },
  menuManageTags: {
    id: 'course-authoring.course-outline.card.menu.manageTags',
    defaultMessage: 'Manage tags',
  },
  readyToSyncButtonAlt: {
    id: 'course-authoring.course-outline.card.button.sync.alt',
    defaultMessage: 'Update available - click to sync',
    description: 'Alt text for the sync icon button.',
  },
});

export default messages;
